export enum TestVerdict {
  WrongAnswer = 'wrong-answer',
  Correct = 'correct',
}
